import { createStore, combineReducers, compose } from "redux";
import actions from "./store/actions";
import { save, get, calculateAllowedVehicles } from "./helpers/helperFunctions";
import Immutable from "immutable";

function auth(state = null, action) {
  if (window.setRavenUser) {
    window.setRavenUser(state);
  }
  let sessionID = 0; //window.getSessionID();
  let auth = get("main-auth") || {};

  window.auth = state;

  switch (action.type) {
    case actions.AUTH_SUCCESS:
      auth = { ...action.data, loggedInAt: Date.now() };
      save("main-auth", auth);
      return auth;
    // do logout
    case actions.AUTH_FAILURE:
      let impuser = get("auth-user");
      if (impuser) {
        localStorage.removeItem("auth-user");
        delete window.originalUser;
        save("main-auth", impuser);
      } else {
        auth = null;
        save("main-auth", null);
      }
      return null;
    default:
      return state;
  }
}

function vehicleMap(state = null, action) {
  switch (action.type) {
    case actions.VEHICLE_MAP_UPDATED:
      return action.data;
    default:
      return state;
  }
}

function geofenceMap(state = null, action) {
  switch (action.type) {
    case actions.GEOFENCE_MAP_UPDATED:
      return action.data;
    default:
      return state;
  }
}

function stats(state = null, action) {
  switch (action.type) {
    case actions.STATS_UPDATED:
      return Object.assign({}, action.data);
    default:
      return state;
  }
}
function searchResult(state = null, action) {
  switch (action.type) {
    case actions.SEARCH_RESULT_UPDATED:
      return action.data;
    default:
      return state;
  }
}

function RTGPS(state = true, action) {
  switch (action.type) {
    case actions.TOGGLE_RTGPS:
      return !state;
    default:
      return state;
  }
}

function statsFilter(state = null, action) {
  switch (action.type) {
    case actions.TOGGLE_STATS_FILTER:
      return action.data;
    default:
      return state;
  }
}

function reportWindow(state = { visible: false, tab: null }, action) {
  window.reportWindow = state;
  switch (action.type) {
    case actions.TOGGLE_REPORT_WINDOW:
      if (!state.visible === false) {
        clearInterval(window.liveDataInterval);
      } else {
        window.liveFlag = true;
      }
      return { ...state, visible: !state.visible };
    case actions.TOGGLE_REPORT_WINDOW_TAB:
      return { ...state, tab: action.data };
    default:
      return state;
  }
}

function roadStats(state = { onroad: true, offroad: false }, action) {
  switch (action.type) {
    case actions.TOGGLE_ONROAD:
      return { onroad: !state.onroad, offroad: state.offroad };
    case actions.TOGGLE_OFFROAD:
      return { onroad: state.onroad, offroad: !state.offroad };
    default:
      return state;
  }
}

function searchString(state = "", action) {
  switch (action.type) {
    case actions.SINGLE_SEARCH:
      return action.data;
    default:
      return state;
  }
}

function graphZoomData(state = null, action) {
  switch (action.type) {
    case actions.GRAPH_ZOOMED:
      return action.data;
    default:
      return state;
  }
}

function graphBrushData(state = null, action) {
  switch (action.type) {
    case actions.GRAPH_BRUSHED:
      return action.data;
    default:
      return state;
  }
}

function gotAllBuckets(state = null, action) {
  switch (action.type) {
    case actions.GOT_ALL_BUCKETS:
      return action.data;
    default:
      return state;
  }
}

function graphSetState(state = 0, action) {
  switch (action.type) {
    case actions.GRAPHSET_STATE_CHANGED:
      return action.data;
    default:
      return state;
  }
}

function overlayFilters(
  state = {
    updatedAt: Date.now(),
    data: {
      lowDB: false,
      lowVB: false,
      noComm: false,
      vehNo: false,
    },
  },
  action
) {
  switch (action.type) {
    case actions.OVERLAY_FILTER_UPDATED:
      return {
        updatedAt: action.data.updatedAt,
        data: { ...state.data, ...action.data.data },
      };
    default:
      return state;
  }
}

function geofenceFilters(
  state = {
    updatedAt: Date.now(),
    data: {
      parking: true,
      servicestation: true,
      competitor: false,
      tollplaza: true,
      citylimit: false,
      other: false,
    },
  },
  action
) {
  switch (action.type) {
    case actions.GEOFENCE_FILTER_UPDATED:
      return {
        updatedAt: action.data.updatedAt,
        data: { ...state.data, ...action.data.data },
      };
    default:
      return state;
  }
}

function InToast(state = { data: [] }, action) {
  switch (action.type) {
    case actions.ADD_INTOAST:
      let s = {
        ...state,
        data: [...state.data, action.data],
        updatedAt: Date.now(),
      };
      if (action.data.replace) {
        s.data = [action.data];
      }
      return s;

    case actions.UPDATE_INTOAST_LIST:
      return { ...state, data: action.data, updatedAt: Date.now() };
    default:
      return state;
  }
}

function InToastLocation(state = { data: [] }, action) {
  switch (action.type) {
    case actions.ADD_INTOAST_LOCATION:
      let s = {
        ...state,
        data: [...state.data, action.data],
        updatedAt: Date.now(),
      };
      if (action.data.replace) {
        s.data = [action.data];
      }
      return s;

    case actions.UPDATE_INTOAST_LOCATION_LIST:
      return { ...state, data: action.data, updatedAt: Date.now() };
    default:
      return state;
  }
}



function selectedVehicle(state = null, action) {
  switch (action.type) {
    case actions.SELECTED_VEHICLE_UPDATED:
      return action.data;
    default:
      return state;
  }
}
function selectedVehicleId(state = null, action) {
  switch (action.type) {
    case actions.SELECTED_VEHICLE_ID:
      return action.data;
    default:
      return state;
  }
}

function userInfo(state = null, action) {
  switch (action.type) {
    case actions.USERINFO_UPDATED:
      return action.data;
    default:
      return state;
  }
}

function userType(state = null, action) {
  switch (action.type) {
    case "UPDATE_USERTYPE":
      return action.data;
    default:
      return state;
  }
}

function evReport(state = null, action) {
  switch (action.type) {
    case "SAVE_EV_REPORT":
      return action.data;
    default:
      return state;
  }
}
function selectedVehicleList(state = [], action) {
  switch (action.type) {
    case "SET_SELECTED_VEHICLE":
      return action.data;
    default:
      return state;
  }
}

function evLoading(state = false, action) {
  switch (action.type) {
    case "SET_EV_LOADING":
      return action.data;
    default:
      return state;
  }
}
function evReportTab(state = 1, action) {
  switch (action.type) {
    case "SET_EV_REPORT_TAB":
      return action.data;
    default:
      return state;
  }
}

function evReportBuckets(state = [], action) {
  switch (action.type) {
    case "SET_EV_REPORT_BUCKET_OPEN":
      let data = state;
      if (data.length > 0 && data.includes(action.payload)) {
        return data.filter((item) => item != action.payload);
      } else {
        return [...data, action.payload];
      }
    default:
      return state;
  }
}

function evDashboard(state = null, action) {
  switch (action.type) {
    case "SAVE_EV_DASHBOARD_DATA":
      return action.data;
    case "UPDATE_EV_DASHBOARD_DATA":
      const newState = { ...state };

      if (action.payload.key === "todaycharging") {
        newState[action.payload.key] = action.payload.data;
      } else {
        newState[action.payload.key].history = action.payload.data;
      }
      return newState;

    default:
      return state;
  }
}

function rightPane(state = null, action) {
  switch (action.type) {
    case actions.RIGHT_PANE_TOGGLED:
      return { ...state, active: action.data, updateAt: Date.now() };

    case actions.RIGHT_PANE_VIEW_CHANGED:
      return { ...state, view: action.data, updateAt: Date.now() };
    default:
      return state;
  }
}

function settingsPane(state = null, action) {
  switch (action.type) {
    case actions.SETTINGS_PANE_TOGGLED:
      return { ...state, active: action.data, updateAt: Date.now() };

    case actions.SETTINGS_PANE_TAB_CHANGED:
      return { ...state, tab: action.data, updateAt: Date.now() };
    default:
      return state;
  }
}
function showDTC(state = null, action) {
  switch (action.type) {
    case actions.DTC_TOGGLED:
      return { ...state, active: action.data, updateAt: Date.now() };

    case actions.DTC_PANE_TAB_CHANGED:
      return { ...state, tab: action.data, updateAt: Date.now() };
    default:
      return state;
  }
}
function groupTree(state = {}, action) {
  switch (action.type) {
    case actions.GROUP_TREE_UPDATE:
      return action.data || state;
    default:
      return state;
  }
}

function leftTree(state = 0, action) {
  switch (action.type) {
    case actions.TOGGLE_LEFT_TREE:
      return action.data;
    default:
      return state;
  }
}

function recentDevices(state = 0, action) {
  switch (action.type) {
    case actions.TOGGLE_RECENT_DEVICES:
      return action.data;
    default:
      return state;
  }
}

function tableView(state = {}, action) {
  switch (action.type) {
    case actions.TOGGLE_TABLE_VIEW:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
function bulkImmob(state = {}, action) {
  switch(action.type) {
    case actions.TOGGLE_BULK_IMMOB:
      return {...state, ...action.data};
    default:
      return state;
  }
}
function lastLoc(state = {}, action) {
  switch (action.type) {
    case actions.TOGGLE_LASTLOC:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
function muteAudio(state = {}, action) {
  switch (action.type) {
    case actions.TOGGLE_MUTE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

function allowedVehicles(state = { updatedAt: Date.now(), data: [] }, action) {
  switch (action.type) {
    case actions.CALCULATE_ALLOWED_VEHICLES:
      return {
        updatedAt: Date.now(),
        data: calculateAllowedVehicles(action.data),
      };
    default:
      return state;
  }
}

function freezMap(state = window.freezMap, action) {
  switch (action.type) {
    case actions.TOGGLE_FREEZ_MAP:
      window.freezMap = { ...state, active: action.data.active };
      return window.freezMap;
    default:
      window.freezMap = state;
      return state;
  }
}

function multiSearchConditions(state = { updatedAt: null, data: [] }, action) {
  switch (action.type) {
    case actions.MULTI_SEARCH_CONDTIONS:
      return {
        data: action.data,
        updatedAt: Date.now(),
      };
    default:
      return state;
  }
}

function DGeofence(
  state = { updatedAt: null, active: false, geofences: {} },
  action
) {
  let currentState = {
    ...state,
  };

  switch (action.type) {
    case actions.UPDATE_DGEOFENCE:
      currentState = {
        ...state,
        geofences: action.data,
        updatedAt: Date.now(),
      };
      break;

    case actions.SET_DGEOFENCE_MODE:
      currentState = {
        ...state,
        ...action.data,
        updatedAt: Date.now(),
      };

      window.map.setOptions({
        draggable: !currentState.active,
        scrollwheel: !currentState.active,
        disableDefaultUI: currentState.active,
      });
      break;

    default:
      currentState = state;
      break;
  }
  return currentState;
}

function showAlarms(state = false, action) {
  if (action.type === actions.TOGGLE_ALARM) state = !state;
  return state;
}

function forgotPassword(state = false, action) {
  if (action.type === "FORGOT_PASSWORD") return action.data;
  return state;
}
function socSorted(state = null, action) {
  switch (action.type) {
    case actions.SOC_SORTED:
      return action.data;
    default:
      return state;
  }
}
function lockUnlock(state = null, action) {
  switch (action.type) {
    case actions.LOCK_BUTTON:
      return action.data;
    default:
      return state;
  }
}

const reducers = {
  auth:auth,
  vehicleMap,
  stats,
  roadStats,
  reportWindow,
  RTGPS,
  statsFilter,
  searchString,
  graphZoomData,
  graphBrushData,
  geofenceMap,
  gotAllBuckets,
  geofenceFilters,
  overlayFilters,
  graphSetState,
  InToast,
  InToastLocation,
  selectedVehicle,
  userInfo,
  rightPane,
  settingsPane,
  groupTree,
  leftTree,
  tableView,
  allowedVehicles,
  freezMap,
  multiSearchConditions,
  DGeofence,
  recentDevices,
  showAlarms,
  showDTC,
  forgotPassword,
  userType,
  evReport,
  evDashboard,
  selectedVehicle,
  searchResult,
  evLoading,
  evReportTab,
  evReportBuckets,
  socSorted,
  selectedVehicleId,
  lockUnlock,
  lastLoc,
  muteAudio,
  bulkImmob,
};

const enhancers = [];
const initialState = {};

const store = createStore(
  combineReducers(reducers),
  window.__REDUX_DEVTOOLS_EXTENSION__ &&
    window.__REDUX_DEVTOOLS_EXTENSION__({
      serialize: {
        replacer: (key, value) => {
          if (Immutable.List.isList(value)) {
            // use your custom data type checker
            return {
              data: value.toArray(), // ImmutableJS custom method to get JS data as array
              __serializedType__: "ImmutableList", // mark you custom data type to show and retrieve back
            };
          }
        },
      },
    })
);

export default store;
